/* olmia-btw.js — btw-poort in de winkelwagen (pagina + lade). Zie snippets/btw-poort.liquid voor het waarom.
   Afrekenen blijft dicht zolang de levering naar een btw-plichtig land (BE/DE) gaat en er geen geldig,
   in VIES gecontroleerd btw-nummer is. Alles wat de koper invult gaat als cart-attribuut mee naar de
   bestelling. Losstaand van olmia-cart.js: die bepaalt de prijsmuur (klasse "hide"), dit script alleen
   de btw-poort (klasse "is-btw-dicht"), zodat de twee elkaar nooit overschrijven. */
(function () {
  const T = (k, f) => (window.olmiaT ? window.olmiaT(k, f) : f);
  const poorten = () => [...document.querySelectorAll('[data-btw-poort]')];
  const eerste = poorten()[0];
  if (!eerste || window.OlmiaBtw) return;
  window.OlmiaBtw = { get open() { return open(); } };
  const ENDPOINT = eerste.dataset.endpoint;
  const PLICHT = (eerste.dataset.plicht || 'EU').split(',');
  const KASSA = '[data-cart-page-checkout],[data-drawer-checkout],a[href^="/checkout"],button[name="checkout"]';
  const A = { land: 'Leverland', nummer: 'Btw-nummer', controle: 'Btw-controle', bedrijf: 'Btw-bedrijf', op: 'Btw-gecontroleerd-op' };

  const s = { land: eerste.dataset.standaardLand || 'NL', nummer: '', controle: '', bedrijf: '', bezig: false, melding: '', soort: '' };

  const nodig = () => PLICHT.includes(s.land);
  const export_ = () => s.land === 'BUITEN-EU';
  const open = () => !nodig() || s.controle === 'geldig' || s.controle === 'niet-gecontroleerd';
  // Buiten de EU: export, geen nummer nodig. Status vastleggen zodat de bestelling het laat zien.
  const status = () => (export_() ? 'buiten-eu' : s.controle);

  // Opslaan in de wagen: strikt NA elkaar en altijd met de stand van dat moment. Twee gelijktijdige
  // /cart/update.js-verzoeken konden anders in de verkeerde volgorde landen, waardoor een oud (ongeldig)
  // btw-nummer het nieuwe (geldige) overschreef. Gemeten 29-09 op mobiel (winkelwagen-check).
  let wachtrij = Promise.resolve();
  let lopend = 0;
  function bewaar(extra) {
    lopend++;
    wachtrij = wachtrij.then(async () => {
      const attributes = { [A.land]: s.land, [A.nummer]: export_() ? '' : s.nummer, [A.controle]: status(), [A.bedrijf]: export_() ? '' : s.bedrijf, ...extra };
      try {
        await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes }) });
      } catch { /* wagen-update mislukt: de ordercontrole (Flow) vangt het op */ }
    }).finally(() => { lopend--; });
    return wachtrij;
  }

  function teken() {
    for (const p of poorten()) {
      const sel = p.querySelector('[data-btw-land]');
      if (sel && sel.value !== s.land) sel.value = s.land;
      const blok = p.querySelector('[data-btw-blok]');
      if (blok) blok.hidden = !nodig();
      const ex = p.querySelector('[data-btw-export]');
      if (ex) ex.hidden = !export_();
      const inp = p.querySelector('[data-btw-input]');
      if (inp && document.activeElement !== inp && inp.value !== s.nummer) inp.value = s.nummer;
      const knop = p.querySelector('[data-btw-knop]');
      if (knop) { knop.disabled = s.bezig; const t = s.bezig ? T('cart.vat_busy', 'Bezig…') : T('cart.vat_check', 'Controleren'); if (knop.textContent !== t) knop.textContent = t; }
      const st = p.querySelector('[data-btw-status]');
      if (st) { const t = nodig() ? s.melding : ''; if (st.textContent !== t) st.textContent = t; st.className = 'btw-poort__status' + (s.soort ? ` is-${s.soort}` : ''); }
    }
    const dicht = !open();
    for (const k of document.querySelectorAll(KASSA)) {
      k.classList.toggle('is-btw-dicht', dicht);
      if (dicht) k.setAttribute('aria-disabled', 'true'); else k.removeAttribute('aria-disabled');
    }
  }

  async function controleer(waarde) {
    s.nummer = String(waarde || '').toUpperCase().replace(/\s+/g, '');
    if (!s.nummer) { s.melding = T('cart.vat_enter', 'Vul je btw-nummer in.'); s.soort = 'fout'; teken(); return; }
    s.bezig = true; s.melding = ''; s.soort = ''; teken();
    let r = null;
    try {
      const res = await fetch(ENDPOINT, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ vat: s.nummer }) });
      if (res.ok) r = await res.json();
    } catch { r = null; }
    s.bezig = false;
    if (r && r.valid === true && r.countryCode !== 'NL') {
      s.nummer = r.countryCode + r.vatNumber; s.controle = 'geldig'; s.bedrijf = r.name || '';
      s.melding = r.name ? T('cart.vat_valid_named', 'Btw-nummer geldig ({name}). Je kunt afrekenen.').replace('{name}', () => r.name) : T('cart.vat_valid', 'Btw-nummer geldig. Je kunt afrekenen.'); s.soort = 'ok';
    } else if (r && r.valid === true && r.countryCode === 'NL') {
      s.controle = 'ongeldig'; s.bedrijf = '';
      s.melding = T('cart.vat_is_dutch', 'Dit is een Nederlands btw-nummer. Levering zonder btw naar een ander EU-land vraagt een btw-nummer uit dat andere land; kies anders Nederland.'); s.soort = 'fout';
    } else if (r && r.valid === false) {
      s.controle = 'ongeldig'; s.bedrijf = '';
      s.melding = r.reason === 'format' ? T('cart.vat_bad_format', 'Dit lijkt geen geldig btw-nummer. Begin met de landcode (bv. BE, FR, DE) en controleer de cijfers.') : T('cart.vat_invalid', 'Dit btw-nummer is niet geldig volgens het EU-register (VIES). Controleer het nummer.');
      s.soort = 'fout';
    } else {
      // VIES of onze controle is even niet bereikbaar: niet blokkeren, wel markeren voor controle achteraf.
      s.controle = 'niet-gecontroleerd'; s.bedrijf = '';
      s.melding = T('cart.vat_unreachable', 'Het EU-register is nu niet bereikbaar. Je kunt afrekenen; wij controleren je btw-nummer daarna.'); s.soort = 'ok';
    }
    teken();
    await bewaar({ [A.op]: new Date().toISOString().slice(0, 16).replace('T', ' ') });
  }

  // Afrekenen tegenhouden zolang de poort dicht is (capture: vóór elke andere klik-afhandeling).
  document.addEventListener('click', (e) => {
    const k = e.target.closest && e.target.closest(KASSA);
    if (!k) return;
    if (open() && lopend > 0) {
      // Poort open, maar er wordt nog opgeslagen: eerst afmaken, dan pas naar de kassa.
      e.preventDefault(); e.stopImmediatePropagation();
      wachtrij.then(() => { window.location.href = k.getAttribute('href') || '/checkout'; });
      return;
    }
    if (open()) return;
    e.preventDefault(); e.stopImmediatePropagation();
    s.melding = T('cart.vat_enter_to_checkout', 'Vul je btw-nummer in en klik op Controleren om af te rekenen.'); s.soort = 'fout';
    teken();
    const inp = k.closest('[data-drawer-foot], .cart-sum, body').querySelector('[data-btw-input]');
    if (inp) inp.focus();
  }, true);

  document.addEventListener('change', (e) => {
    if (!e.target.matches || !e.target.matches('[data-btw-land]')) return;
    s.land = e.target.value;
    if (!nodig()) { s.melding = ''; s.soort = ''; }
    teken(); bewaar();
  });
  document.addEventListener('click', (e) => {
    const knop = e.target.closest && e.target.closest('[data-btw-knop]');
    if (!knop) return;
    controleer(knop.closest('[data-btw-poort]').querySelector('[data-btw-input]').value);
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Enter' || !e.target.matches || !e.target.matches('[data-btw-input]')) return;
    e.preventDefault(); controleer(e.target.value);
  });
  // Nummer gewijzigd na een geldige controle: opnieuw controleren vereist.
  document.addEventListener('input', (e) => {
    if (!e.target.matches || !e.target.matches('[data-btw-input]')) return;
    const nieuw = e.target.value.toUpperCase().replace(/\s+/g, '');
    if (nieuw !== s.nummer && s.controle) { s.controle = ''; s.bedrijf = ''; s.melding = ''; s.soort = ''; s.nummer = nieuw; teken(); }
  });

  // Hertekenen als de wagen (lade/pagina) nieuwe knoppen rendert.
  let gepland = false;
  new MutationObserver(() => { if (gepland) return; gepland = true; requestAnimationFrame(() => { gepland = false; teken(); }); })
    .observe(document.body, { childList: true, subtree: true });

  // Stand herstellen uit de wagen (bv. na herladen of op /cart na de lade).
  fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json()).then((c) => {
    const at = c.attributes || {};
    if (at[A.land] && ['NL', 'EU', 'BUITEN-EU'].includes(at[A.land])) s.land = at[A.land];
    s.nummer = at[A.nummer] || '';
    s.controle = at[A.controle] === 'buiten-eu' ? '' : (at[A.controle] || '');
    s.bedrijf = at[A.bedrijf] || '';
    if (s.controle === 'geldig') { s.melding = s.bedrijf ? T('cart.vat_valid_named', 'Btw-nummer geldig ({name}). Je kunt afrekenen.').replace('{name}', () => s.bedrijf) : T('cart.vat_valid', 'Btw-nummer geldig. Je kunt afrekenen.'); s.soort = 'ok'; }
    teken();
    // Gevulde wagen zonder leverland: de standaard (NL/EU/BUITEN-EU) meteen vastleggen, zodat elke bestelling het draagt.
    if (c.item_count > 0 && !at[A.land]) bewaar();
  }).catch(() => teken());
  teken();
})();
